import { Outlet, Link } from 'react-router-dom';
import '../App.css';
import { useEffect, useRef, useState } from 'react';
import { useAppContext } from '../context/Context';

const Menu = () => {

    // context provided
    const { isScrolled, setIsScrolled } = useAppContext();

    const containerRef = useRef(null);

    useEffect(() => {
            const container = containerRef.current;
            if (container) {
                function handleScroll() {
                    setIsScrolled(container.scrollTop > 1?'0px':'40px');
                }
                container.addEventListener('scroll', handleScroll);
                return() => {
                    container.removeEventListener('scroll', handleScroll);
            }
        }
    }, []);
    /*
                    <div className='box button headbannerbutton'>
                        Shop
                    </div>
                    <div className='box button headbannerbutton'>
                        <Link to="brbtx">BRbtx</Link>
                    </div>
                    <div className='box button headbannerbutton'>
                        <Link to="pb">PB</Link>
                    </div>
    */

    return (
        <div ref={containerRef} className='container'>
            <div className='headbanner box' style={{height:isScrolled}}>
                <div className='box bannerbuttons'>
                    <Link className='box button headbannerbutton' to="wbw">WBW</Link>
                    <Link className='box button headbannerbutton' to="terms">Terms</Link>
                </div>
                <div className='box text' style={{marginRight:'10px'}}>
                    <Link to="">Teejeigh</Link>
                </div>
            </div>
            <Outlet />
        </div>
    )
}
export default Menu;
